import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-140">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-[100]" onClick={onClose} data-id="element-141" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:max-w-2xl md:w-full md:max-h-[80vh] bg-white rounded-2xl shadow-2xl z-[101] flex flex-col overflow-hidden" data-id="element-142">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0" data-id="element-143">
              <h3 className="text-xl font-bold text-[#7B2D3B] font-serif" data-id="element-144">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700" data-id="element-145">
                <XIcon className="w-5 h-5" data-id="element-146" />
              </button>
            </div>
            <div className="px-6 py-6 overflow-y-auto text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-147">
              {children}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}
export function PrivacyPolicyContent() {
  return <>
      <p data-id="element-148">
        <strong data-id="element-149">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-150">
        En El Plan de Rescate, respetamos tu privacidad y nos comprometemos a
        proteger tu información personal. Esta política describe cómo
        recopilamos, usamos y protegemos tus datos.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-151">
        1. Información que recopilamos
      </h4>
      <p data-id="element-152">
        Recopilamos información que nos proporcionas directamente, como tu
        nombre y dirección de correo electrónico al realizar una compra. También
        recopilamos información de pago a través de nuestro procesador de pagos
        seguro.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-153">
        2. Uso de la información
      </h4>
      <p data-id="element-154">
        Utilizamos tu información para procesar tu compra, enviarte el producto
        digital, y comunicarnos contigo sobre tu pedido. No vendemos ni
        compartimos tu información personal con terceros para fines de
        marketing.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-155">
        3. Protección de datos
      </h4>
      <p data-id="element-156">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-157">4. Cookies</h4>
      <p data-id="element-158">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar la funcionalidad del sitio.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-159">5. Contacto</h4>
      <p data-id="element-160">
        Si tienes preguntas sobre esta política de privacidad, puedes
        contactarnos a través de nuestro correo electrónico de soporte.
      </p>
    </>;
}
export function TermsOfServiceContent() {
  return <>
      <p data-id="element-161">
        <strong data-id="element-162">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-163">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, aceptas los siguientes términos y condiciones.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-164">
        1. Producto digital
      </h4>
      <p data-id="element-165">
        El Plan de Rescate es un producto educativo en formato digital (Kit de
        Rescate Financiero). Al completar tu compra, recibirás acceso inmediato
        y permanente para descargar el material.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-166">
        2. Uso permitido
      </h4>
      <p data-id="element-167">
        El contenido es para tu uso personal únicamente. No está permitido
        reproducir, distribuir, vender o compartir el material sin autorización
        expresa por escrito.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-168">
        3. Descargo de responsabilidad
      </h4>
      <p data-id="element-169">
        Este producto es de carácter educativo e informativo. No constituye
        asesoría legal, financiera ni fiscal. Los resultados pueden variar según
        las circunstancias individuales de cada persona. Recomendamos consultar
        con un profesional calificado para situaciones específicas.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-170">
        4. No afiliación gubernamental
      </h4>
      <p data-id="element-171">
        Este sitio y sus productos no están afiliados, respaldados ni asociados
        con la Administración del Seguro Social (SSA), el IRS ni ninguna agencia
        gubernamental de los Estados Unidos.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-172">
        5. Política de reembolso
      </h4>
      <p data-id="element-173">
        Debido a la naturaleza digital del producto y el acceso inmediato
        proporcionado, todas las ventas son finales. Si tienes algún problema
        con tu compra, contáctanos y haremos lo posible por ayudarte.
      </p>

      <h4 className="font-bold text-[#7B2D3B] text-base mt-4" data-id="element-174">
        6. Modificaciones
      </h4>
      <p data-id="element-175">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos al momento de su publicación en
        este sitio.
      </p>
    </>;
}